import React from "react";

export function Button({ text, onClick }) {
  return (
    <button className="btn btn-sm btn-outline-secondary ml-3" onClick={onClick}>
      {text}
    </button>
  );
}

export const getAuthHost = () => {
  const { hostname } = window.location;

  if (hostname.includes("localhost")) {
    return "login.test.api.sustainabilitytool.com";
  }

  if (hostname.endsWith(".api.sustainabilitytool.com")) {
    return hostname;
  }

  if (hostname.endsWith(".sustainabilitytool.com")) {
    return hostname.replace(
      ".sustainabilitytool.com",
      ".api.sustainabilitytool.com",
    );
  }

  return "login.api.sustainabilitytool.com";
};
